export const environment = {
  production: false,
  apiUrl: "https://mirl.appening.xyz",
  mirlAppToken:
    "Bearer 9e03fddc477f8dddf89ca6b608d1c6cccdc882ccd104dbafcdb02ff8edd419296937b1b6562db403c0be150a0a432f70c5e13csdsj232sdbb3438cbdf",
};
